import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input'];

  inputTarget: HTMLInputElement;

  expand() {
    this.element.classList.add('is-expanded');
    this.inputTarget.value = 'true';
  }
}
